import ProcurementTenderType from './ProcurementTenderType';

export const getProcurementTenderListInProgress = (payload) => {
  return { type: ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST, payload };
};

export const getProcurementTenderListInSuccess = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST_SUCCESS,
    payload,
  };
};

export const getProcurementTenderListInFail = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST_FAIL,
    payload,
  };
};

export const updateProcurementTenderInfoRequest = (payload) => {
  return {
    type: ProcurementTenderType.UPDATE_PROCUREMENT_TENDER_INFO_REQUEST,
    payload,
  };
};

export const getProcurementTenderListRequestReset = () => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST_REQUEST_RESET,
  };
};

export const checkTenderNameIsExists = (payload) => {
  return { type: ProcurementTenderType.CHECK_TENDER_NAME_IS_EXISTS, payload };
};

export const checkTenderNameIsExistsSuccess = (payload) => {
  return {
    type: ProcurementTenderType.CHECK_TENDER_NAME_IS_EXISTS_SUCCESS,
    payload,
  };
};

export const checkTenderNameIsExistsFail = (payload) => {
  return {
    type: ProcurementTenderType.CHECK_TENDER_NAME_IS_EXISTS_FAIL,
    payload,
  };
};
export const setActiveTenderItemsRequest = (payload) => {
  return {
    type: ProcurementTenderType.SET_ACTIVE_TENDER_ITEM,
    payload,
  };
};

export const resetActiveTenderItemsRequest = () => {
  return {
    type: ProcurementTenderType.RESET_ACTIVE_TENDER_ITEM,
  };
};
/** get Tender copy action start */

export const getTenderCopyInProgress = (payload) => {
  return {
    type: ProcurementTenderType.CREATE_TENDER_COPY,
    payload,
  };
};

export const getTenderCopyInSuccess = (payload) => {
  return {
    type: ProcurementTenderType.CREATE_TENDER_COPY_SUCCESS,
    payload,
  };
};

export const getTenderCopyInFail = (payload) => {
  return {
    type: ProcurementTenderType.CREATE_TENDER_COPY_FAIL,
    payload,
  };
};

export const getTenderCopyRequestReset = () => {
  return {
    type: ProcurementTenderType.CREATE_TENDER_COPY_RESET,
  };
};

/** get Tender copy action end */

export const getUpdateTenderProgress = (payload) => {
  return {
    type: ProcurementTenderType.UPDATE_TENDER_PROGRESS,
    payload,
  };
};

export const getUpdateTenderSuccess = (payload) => {
  return {
    type: ProcurementTenderType.UPDATE_TENDER_SUCCESS,
    payload,
  };
};

export const getUpdateTenderError = () => {
  return {
    type: ProcurementTenderType.UPDATE_TENDER_ERROR,
  };
};

export const getTenderDocumentsListInProgress = (payload) => {
  return { type: ProcurementTenderType.GET_DOCUMENTS_PROGRESS, payload };
};

export const getTenderDocumentsListInSuccess = (payload) => {
  return { type: ProcurementTenderType.GET_DOCUMENTS_SUCCESS, payload };
};

export const getTenderDocumentsListInError = (payload) => {
  return { type: ProcurementTenderType.GET_DOCUMENTS_ERROR, payload };
};

export const getProcurementBidParameterInProgress = (payload) => {
  return { type: ProcurementTenderType.GET_PROCUREMENT_BID_PARAMETER, payload };
};

export const getProcurementBidParameterInSuccess = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_BID_PARAMETER_SUCCESS,
    payload,
  };
};

export const getProcurementBidParameterInFail = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_BID_PARAMETER_FAIL,
    payload,
  };
};

export const getProcurementBidParameterRequestReset = () => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_BID_PARAMETER_REQUEST_RESET,
  };
};

export const addNewBidParameterBtn = (payload) => {
  return {
    type: ProcurementTenderType.ADD_NEW_BID_PARAMETER_ACTION,
    payload,
  };
};

export const addNewLaneBtn = (payload) => {
  return {
    type: ProcurementTenderType.ADD_NEW_LANE_BUTTON,
    payload,
  };
};

export const getProcurementLaneInformationInProgress = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION,
    payload,
  };
};

export const getProcurementLaneInformationInSuccess = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION_SUCCESS,
    payload,
  };
};

export const getProcurementLaneInformationInFail = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION_FAIL,
    payload,
  };
};

export const getProcurementLaneInformationRequestReset = () => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION_REQUEST_RESET,
  };
};

export const getProcurementAddLaneInformationInProgress = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION,
    payload,
  };
};

export const getProcurementAddLaneInformationInSuccess = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION_SUCCESS,
    payload,
  };
};

export const getProcurementAddLaneInformationInFail = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION_FAIL,
    payload,
  };
};

export const getProcurementAddLaneInformationRequestReset = () => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION_REQUEST_RESET,
  };
};
export const getTenderCarrierListInProgress = (payload) => {
  return { type: ProcurementTenderType.GET_TENDER_CARRIER_LIST, payload };
};

export const getTenderCarrierListInSuccess = (payload) => {
  return {
    type: ProcurementTenderType.GET_TENDER_CARRIER_LIST_SUCCESS,
    payload,
  };
};

export const getTenderCarrierListInFail = (payload) => {
  return {
    type: ProcurementTenderType.GET_TENDER_CARRIER_LIST_FAIL,
    payload,
  };
};

export const getTenderCarrierListRequestReset = () => {
  return {
    type: ProcurementTenderType.GET_TENDER_CARRIER_LIST_REQUEST_RESET,
  };
};

export const getProcurementHistoricalBidListInProgress = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST,
    payload,
  };
};

export const getProcurementHistoricalBidListInSuccess = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST_SUCCESS,
    payload,
  };
};

export const getProcurementHistoricalBidListInFail = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST_FAIL,
    payload,
  };
};

export const getProcurementHistoricalBidListRequestReset = () => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST_REQUEST_RESET,
  };
};

export const getProcurementTransportProviderInProgress = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER,
    payload,
  };
};

export const getProcurementTransportProviderInSuccess = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER_SUCCESS,
    payload,
  };
};

export const getProcurementTransportProviderInFail = (payload) => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER_FAIL,
    payload,
  };
};

export const getProcurementTransportProviderRequestReset = () => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER_REQUEST_RESET,
  };
};
